module.exports = __webpack_public_path__ + "0aae561b9bc8c775fa8641ab57474952.pdf";